// client/src/components/Achievements/DailyResetTimer.jsx
import React, { useState, useEffect } from "react";
import { getMsUntilNextManilaMidnight, formatHMS } from "./achievementsConfig";

const DailyResetTimer = React.memo(function DailyResetTimer() {
  const [resetMs, setResetMs] = useState(getMsUntilNextManilaMidnight());

  useEffect(() => {
    const t = setInterval(() => {
      setResetMs(getMsUntilNextManilaMidnight());
    }, 1000);

    return () => clearInterval(t);
  }, []);

  return (
    <span className="text-xs text-gray-400 font-medium bg-gray-50 px-2 py-1 rounded-lg">
      Resets in {formatHMS(resetMs)}
    </span>
  );
});

export default DailyResetTimer;
